
import { defineComponent } from 'vue'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'

export default defineComponent({
  components: {
    DismissibleAlert
  },
  props: {
    isSucceed: {
      type: Boolean,
      required: true
    },
    successMessage: {
      type: String,
      default: '登録しました。'
    },
    errorMessage: {
      type: String as () => string | null,
      default: null
    }
  },
  emits: {
    dismiss: () => true
  },
  setup (_, { emit }) {
    const dismiss = () => {
      emit('dismiss')
    }

    return {
      dismiss
    }
  }
})
